import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './pages/home/home';
import Propose from './pages/propose/propose';
import IndividualPropose from './pages/individualPropose/individualPropose';
import ArcadeQuestProposal from './pages/arcadeQuestProposal/arcadeQuestProposal';
import DeliveryBizConnectProposal from './pages/DeliveryBizConnectProposal/DeliveryBizConnectProposal';
import Token from './pages/buy-voton/token';
import NoMatch from './pages/404/404';

function App() {
  return (
    <React.Fragment>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/propose" element={<Propose/>} />
          <Route path="/buy-voton" element={<Token/>} />
          <Route path="/individualPropose" element={<IndividualPropose/>} />
          <Route path="/arcadeQuestProposal" element={<ArcadeQuestProposal/>} />
          <Route path="/deliveryBizConnectProposal" element={<DeliveryBizConnectProposal/>} />
          <Route path="*" element={<NoMatch/>} />
        </Routes>
      </Router>
    </React.Fragment>
  );
}

export default App;
